export default {
  enabled: true,
  bodyClass: true,
  thresholds: {
    xs: 0,
    sm: 320,
    md: 640,
    lg: 1024,
    xl: 1440,
  },
}
